/**
 * c-reveal.js
 *
 * Shared scroll-reveal behaviour for the `c-*` sections. Any element carrying
 * the `c-reveal` class fades and slides in once it enters the viewport.
 *
 * The script initialises itself once per page no matter how many sections load
 * it, and re-scans on Shopify's theme editor events so newly inserted sections
 * animate correctly inside the customizer.
 */
(function () {
  if (window.__cRevealReady) return;
  window.__cRevealReady = true;

  var REVEALED = 'is-revealed';
  var FALLBACK_MS = 4000;

  var reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Without IntersectionObserver, or with reduced motion on, everything is
     shown immediately rather than left invisible. */
  if (reducedMotion || typeof IntersectionObserver === 'undefined') {
    document.querySelectorAll('.c-reveal').forEach(function (el) {
      el.classList.add(REVEALED);
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(REVEALED);
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0, rootMargin: '0px 0px -8% 0px' }
  );

  function scan(root) {
    (root || document).querySelectorAll('.c-reveal:not(.' + REVEALED + ')').forEach(function (el) {
      observer.observe(el);
    });
  }

  scan();

  /* Safety net: if an observer callback never fires (hidden tab, aggressive
     browser throttling) nothing should stay permanently invisible. */
  setTimeout(function () {
    document.querySelectorAll('.c-reveal').forEach(function (el) {
      el.classList.add(REVEALED);
    });
  }, FALLBACK_MS);

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
